import { useCallback } from "react";
import { FilterBar, type FilterConfig } from "@/components/admin/shared/FilterBar";
import {
  BRAND_OPTIONS,
  CATEGORY_OPTIONS,
} from "@/lib/validation/product";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface ProductFilterValues {
  readonly brand: string | null;
  readonly category: string | null;
  readonly status: string | null;
  readonly stock: string | null;
}

export interface ProductFiltersProps {
  readonly values: ProductFilterValues;
  readonly onChange: (next: ProductFilterValues) => void;
}

// ---------------------------------------------------------------------------
// Filter configuration
// ---------------------------------------------------------------------------

const FILTER_CONFIGS: readonly FilterConfig[] = [
  {
    key: "brand",
    label: "Marque",
    type: "select",
    options: BRAND_OPTIONS.map((b) => ({ value: b.value, label: b.label })),
  },
  {
    key: "category",
    label: "Catégorie",
    type: "select",
    options: CATEGORY_OPTIONS.map((c) => ({ value: c.value, label: c.label })),
  },
  {
    key: "status",
    label: "Statut",
    type: "select",
    options: [
      { value: "active", label: "Actif" },
      { value: "inactive", label: "Inactif" },
    ],
  },
  {
    key: "stock",
    label: "Stock",
    type: "select",
    options: [
      { value: "low", label: "Stock faible" },
      { value: "out", label: "Rupture de stock" },
      { value: "ok", label: "En stock" },
    ],
  },
];

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function ProductFilters({ values, onChange }: ProductFiltersProps) {
  const handleChange = useCallback(
    (key: string, value: unknown) => {
      onChange({
        ...values,
        [key]: (value as string) || null,
      });
    },
    [values, onChange],
  );

  return (
    <FilterBar
      filters={FILTER_CONFIGS}
      values={values as unknown as Readonly<Record<string, unknown>>}
      onChange={handleChange}
    />
  );
}
